import { useEffect, useRef } from 'react';
import mermaid from 'mermaid';

mermaid.initialize({
  startOnLoad: false,
  theme: 'default',
  securityLevel: 'loose',
  flowchart: {
    htmlLabels: true,
    curve: 'basis',
  },
});

type MermaidDiagramProps = {
  diagram: string;
};

export default function MermaidDiagram( { diagram }: MermaidDiagramProps ) {
 
  const mermaidRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const renderMermaid = async () => {

      if (mermaidRef.current) {
        // mermaidRef.current.innerHTML = '';
        
        try {
          const { svg } = await mermaid.render('mermaid-diagram', diagram);

          console.log( 'render', diagram )
          // Inject the SVG into the container
          mermaidRef.current.innerHTML = svg;
        } catch (error) {
          console.error('Error rendering mermaid diagram:', error);
        }
      }
    };

    setTimeout(renderMermaid, 100); // render fix
    
  }, [diagram]);

  return (
    <div className="flex flex-col items-center justify-center w-full h-full bg-white p-8">
      <div className="w-full h-full flex flex-col">
        {/* <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">🧠 Mind Map 🗺️</h2> */}
        <div className="flex-1 bg-gray-50 rounded-lg shadow-md p-4 overflow-hidden">
          <div
            ref={mermaidRef}
            className="w-full h-full flex justify-center items-center overflow-auto"
          ></div>
        </div>
      </div>
    </div>
  );
}